@if (cart$ | async; as cart) {
  <h2 [hidden]="true" id="summaryLabelId">{{ 'checkoutReview.summary' | cxTranslate }}</h2>
  <div aria-labelledby="summaryLabelId" class="price-summary">
    @if (isTaxEnabled) {
    <div class="price-summary__total text-grey">
      <div class="d-flex justify-content-between" data-cy="net-price">
        <h4 class="body--xs">{{ 'checkoutReview.total' | cxTranslate }}</h4>
        <span class="body--xs">{{ cart?.totalPrice?.formattedValue }}</span>
      </div>
      <div class="d-flex justify-content-between udex-mt-4" data-cy="estimated-tax">
        <h4 class="body--xs">{{ 'checkoutReview.estimatedTax' | cxTranslate }}</h4>
        @if (!foundTaxErrorSeverity) {
          <span class="body--xs">{{ cart?.totalTax?.formattedValue }}</span>
        } @else {
          <span
            class="tax-error body--xs"
            [class.warning]="foundTaxErrorSeverity == 'warning'"
            [class.error]="foundTaxErrorSeverity == 'error'"
            data-cy="found-tax-error"
          >{{ 'checkoutReview.estimatedTaxError' | cxTranslate }}
          </span>
        }
      </div>
      @if (isEstimatedTaxTitleEnabled) {
        <div
          class="text-grey d-flex justify-content-end align-items-center price-summary__tax-info"
          data-cy="estimated-tax-info">
          <span class="body--xs">{{ 'checkoutReview.importantTaxInfo' | cxTranslate }}</span>
          <dcp-icon-button-tooltip [placement]="'Bottom'" [openOnClick]="true">
            <div class="body--s price-summary__tooltip-content">
              {{ 'checkoutReview.importantTaxInfoTooltip' | cxTranslate }}
            </div>
          </dcp-icon-button-tooltip>
        </div>
      }
      @if (foundTaxErrorSeverity) {
        <udex-message-strip
          status-type="Icon"
          data-cy="tax-error-message"
          hide-close-button
          [design]="getFormattedSeverity(foundTaxErrorSeverity)"
          [ngClass]="isEstimatedTaxTitleEnabled ? 'udex-mt-12' : 'udex-mt-20' "
        >
          <span style="vertical-align: middle" class="body--s">
            {{ 'checkoutReview.error.taxCalculation.' + ( cart?.paymentType?.code | lowercase )  | cxTranslate }}
          </span>
        </udex-message-strip>

      }
      <div class="price-separator udex-pb-16 udex-mb-16"></div>
    </div>
    }
    <div class="d-flex justify-content-between price-summary__title text-black">
      <div class="text-start">
        <h3 class="d-flex align-items-center" data-cy="total-price-text">
          @if (cart?.totalPrice?.value === 0) {
            <dcp-icon-button-tooltip class="udex-pe-4" data-cy="checkout-initial-cost" [openOnClick]="true">
              <span>{{ 'checkoutReview.initialCostTooltip' | cxTranslate }}</span>
            </dcp-icon-button-tooltip>
          }
          <h3 class="body--l">{{ 'checkoutReview.' + totalTitle(cart) | cxTranslate }}</h3>
        </h3>
      </div>
      <div class="text-end">
        @if (cartContainsError) {
          <dcp-error-indicator class="d-flex justify-content-end"></dcp-error-indicator>
        } @else if (cart?.totalPrice) {
          <h3 class="heading__medium--xxs udex-py-4" data-cy="total-price">
            {{ getTotalPrice(cart) }}
          </h3>
        }
        @if (!isTaxEnabled) {
          <p class="price-summary__title__tax-disclaimer text-blue-gray body--xxs">
            {{ 'configurator.taxCalculationCheckout' | cxTranslate }}
          </p>
        }
      </div>
    </div>
  </div>
  <div class="price-separator udex-pb-16 udex-mb-20"></div>
}
